import { forwardRef, type LabelHTMLAttributes } from "react";
import { cn } from "@ridereserv/shared/utils";

export interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
  required?: boolean;
}

/**
 * Label component for form fields.
 * Uses semantic color tokens from the design system.
 */
const Label = forwardRef<HTMLLabelElement, LabelProps>(
  ({ className, required, children, ...props }, ref) => {
    return (
      <label
        ref={ref}
        className={cn(
          "text-sm font-medium leading-none text-neutral-700",
          "peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
          className
        )}
        {...props}
      >
        {children}
        {required && <span className="ml-1 text-destructive-500">*</span>}
      </label>
    );
  }
);

Label.displayName = "Label";

export { Label };
